import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=b9d80f70&"
import script from "./collection.js?vue&type=script&lang=js&"
export * from "./collection.js?vue&type=script&lang=js&"
import style0 from "./collection.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports